module.exports = __webpack_public_path__ + "r-v3/img/ico_x.aaccc185.svg";